import type { UUID } from '@aline/common';
import type { PartySubset } from 'src/components/workflow/WorkflowPartiesPopover';
import { v4 as uuid4 } from 'uuid';

const PENDING_PARTY_ID_PREFIX = 'pending-party:';

/**
 * A party the user just typed that the server has not created yet. It can sit in
 * a selection like any other party; the set-parties mutations send it by name and
 * the server finds or creates the real party in the same request.
 */
export function createPendingParty(name: string): PartySubset {
  return { __typename: 'Party', id: `${PENDING_PARTY_ID_PREFIX}${uuid4()}`, name: name.trim() };
}

export function getIsPendingParty(party: Pick<PartySubset, 'id'>): boolean {
  return party.id.startsWith(PENDING_PARTY_ID_PREFIX);
}

export function splitPendingParties(parties: readonly PartySubset[]): {
  newPartyNames: string[];
  partyIds: UUID[];
} {
  return {
    newPartyNames: parties.filter(getIsPendingParty).map(party => party.name),
    partyIds: parties.filter(party => !getIsPendingParty(party)).map(party => party.id),
  };
}
